module.exports = __webpack_public_path__ + "img/chinesecompany146.1e06b6df.png";